import { html } from "lit-html";
import { ifDefined } from "lit/directives/if-defined.js";
import {
  appendRequiredAsterisk,
  getInfoBox,
  getLabel,
} from "Components/abstract/sc-e-form-field/sc-e-form-field.template";

import { ScTextInput } from "./sc-e-text-input";
import { TextInputRenderArgs } from "./sc-e-text-input.types";

export type TextInputTemplateArgs = {
  component: ScTextInput;
  keyupCb?: () => void;
};

/**
 * Return TemplateResult of formfield input
 * @param {FormFieldInputRenderArgs} args
 * @returns {TemplateResult}
 */
const renderInput = (args: TextInputRenderArgs) => {
  return html`
    <input
      type="${args.type}"
      placeholder="${args.isRequired ? appendRequiredAsterisk(args.placeholder, args.isRequired) : args.placeholder}"
      class="sc-e-form-field__input sc-js-form-field__input"
      name="${args.name}"
      aria-describedby="info-box-${args.id}"
      id="${args.id}"
      ?required=${args.isRequired}
      ?disabled=${args.isDisabled}
      ?readonly=${args.isReadonly}
      tabindex=${ifDefined(args.isReadonly ? "-1" : undefined)}
      minlength=${args.minlength || "auto"}
      maxlength=${args.maxlength || "auto"}
      autocomplete="${ifDefined(args.autocompleteType)}"
      pattern="${ifDefined(args.pattern)}"
      @keyup=${args.keyupCb}
    />
  `;
};

// prettier-ignore
export const textInputTemplate = (args: TextInputTemplateArgs) => {
  return html`
    <div class="sc-e-form-field__box">
      ${getLabel({
        for: args.component.id,
        isRequired: args.component.isRequired,
        label: args.component.label
      })}
      ${renderInput({
        autocompleteType: args.component.autocompleteType,
        errorMessage: args.component.errorMessage,
        description: args.component.description,
        isDisabled: args.component.isDisabled,
        isRequired: args.component.isRequired,
        isReadonly: args.component.isReadonly,
        label: args.component.label,
        name: args.component.name,
        placeholder: args.component.placeholder,
        showError: args.component.state.showError,
        type: args.component.type,
        id: args.component.id,
        keyupCb: args.keyupCb,
        minlength: args.component.minlength,
        maxlength: args.component.maxlength,
        pattern: args.component.valuePattern,
      })}
    </div>
    ${getInfoBox<string, ScTextInput>({
      formField: args.component
    })}
  `;
};
